import {
  NUMBER_0,
  NUMBER_1,
  NUMBER_10,
  NUMBER_100,
  NUMBER_2,
} from "constants/numbers";

/**
 * Convert semantic app version into int.
 * @param appVersion {string}
 * @returns {int} - number representing version where major.minor.fix is represented as int XXYY where XX is minor and YY fix. If there is no version specified, return 0
 */
const convertSemanticVersion = (appVersion: string | undefined): number => {
  const appVersionSemantic = appVersion && appVersion.split(".").map(Number);

  if (appVersionSemantic) {
    let minor = appVersionSemantic[NUMBER_1];
    if (minor < NUMBER_10) {
      minor *= NUMBER_100;
    } else if (minor < NUMBER_100) {
      minor *= NUMBER_10;
    }

    const patch = appVersionSemantic[NUMBER_2];

    return minor + patch;
  } else {
    return NUMBER_0;
  }
};

export default convertSemanticVersion;
